//TODO: Check if this type is deprecated, it doesnt seem to match the API response
export type Report = {
    from: string,
    to: string,
    entries: ReportEntry[]
}

export enum ReportType {
    BALREP = 'BALREP',
    PROFLOS = 'PROFLOS',
    GENLEG = 'GENLEG',
    TRIBAL = 'TRIBAL',
    INVJOU = 'INVJOU',
    TRANSACTION_JOURNAL = 'TRANSACTION_JOURNAL'
}

export type ReportEntry = {
    groupedBy: string,
    incoming?: number,
    movements: Movement[],
    outgoing?: number
}

export type Movement = {
    period: string,
    amount: number,
    count?: number
}

export type InvoiceTrend = {
    invoiced: number,
    outstanding: number,
    paid: number,
    overdue: number,
    invoicedPrevYear: number,
    invoicedThisYear: number,
}

type MonthlyMovement = {
    year: number,
    month: number,
    transactionLineCount: number,
    amount: number
}

export type ReportGroup = {
    name: string,
    incomingBalance: number,
    outgoingBalance: number,
    monthlyMovements: MonthlyMovement[],
    groups: ReportGroup[],
    ranges?: Array<{min: string, max: string}>,
}

export type SummaryReportData = {
    fromDate: string
    toDate: string
    name: string
    groups: ReportGroup[]
}



export class SummaryReport {
    data: SummaryReportData
    getGroupByName: (name: string) => ReportGroup | undefined

    constructor(data: SummaryReportData) {
        this.data = data

        this.getGroupByName = (name: string) => {
           //search recursively for a group by name
            const searchGroup = (group: ReportGroup): ReportGroup | undefined => {
                if (group.name === name) {
                    return group
                }
                for (const subGroup of group.groups || []) {
                    const found = searchGroup(subGroup)
                    if (found) {
                        return found
                    }
                }
                return undefined
            }

            for (const group of this.data.groups) {
                const found = searchGroup(group)
                if (found) {
                    return found
                }
            }
            return undefined
        }

    }
}